<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`${keyPrefix}-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// common
import Separator from '~/components/library/Separator.vue';
import FormContainer from '~/components/library/FormContainer.vue';
import InfoCard from '~/components/theme6/components/InfoCard.vue';
import MeetCard from '~/components/theme6/components/MeetCard.vue';
import LatestProperties from '~/components/theme6/properties/LatestProperties.vue';
import OurBlogSidebar from '~/components/theme6/sidebar/OurBlogSidebar.vue';
import OurGuide from '~/components/theme6/components/OurGuide.vue';
import ManageCard from '~/components/library/ManageCard.vue';
import FormCard from '~/components/theme6/components/FormCard.vue';

export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },

    keyPrefix: {
      required: false,
      type: String,
      default: 'dynamicComponent',
    },
  },

  components: {
    Separator,
    FormContainer,
    InfoCard,
    MeetCard,
    LatestProperties,
    OurBlogSidebar,
    OurGuide,
    FormCard,
    ManageCard,
  },
});
</script>
